function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import Radio, { radioClasses } from '@mui/material/Radio';
import { buttonBaseClasses } from '@mui/material/ButtonBase';
import { oneOf, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import { RadioButtonChecked, RadioButtonUnchecked } from 'mosaic-react-icons';
import { getFocusStyles } from '../internals/utils';
const styledIcon = Icon => styled(Icon)(_ref => {
  let {
    size,
    theme: {
      spacing
    }
  } = _ref;
  return {
    fontSize: spacing(size === 'small' ? 2.5 : 3)
  };
});
const StyledRadio = styled(Radio)(_ref2 => {
  let {
    size,
    theme: {
      spacing,
      palette
    }
  } = _ref2;
  const factor = size === 'small' ? 4 : 5;
  return {
    width: spacing(factor),
    height: spacing(factor),
    ["&.".concat(buttonBaseClasses.focusVisible)]: {
      ...getFocusStyles({
        offset: -4
      })
    },
    ["&.".concat(radioClasses.disabled)]: {
      color: palette.text.disabled
    }
  };
});
const StyledCheckedIcon = styledIcon(RadioButtonChecked);
const StyledUncheckedIcon = styledIcon(RadioButtonUnchecked);
const SovosRadio = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    className,
    size,
    ...otherProps
  } = _ref3;
  return /*#__PURE__*/React.createElement(StyledRadio, _extends({
    checkedIcon: /*#__PURE__*/React.createElement(StyledCheckedIcon, {
      size: size
    }),
    className: clsx('sovosRadio', className),
    disableFocusRipple: true,
    icon: /*#__PURE__*/React.createElement(StyledUncheckedIcon, {
      size: size
    }),
    ref: ref,
    size: size
  }, otherProps));
});
SovosRadio.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * The color of the radio button
   */
  color: oneOf(['primary', 'default']),
  /**
   * The size of the radio button
   */
  size: oneOf(['medium', 'small'])
};
SovosRadio.defaultProps = {
  className: undefined,
  color: 'primary',
  size: 'medium'
};
SovosRadio.baseComponent = {
  name: 'Radio',
  link: 'radio/'
};
export default SovosRadio;